import React from "react";
import languageData from "./data";
import { Dropdown } from "antd";
import {
  useLocaleActionsContext,
  useLocaleContext,
} from "@lib/context/AppContextProvider/LocaleContextProvider";
// import { useLayoutActionsContext } from "@lib/context/AppContextProvider/LayoutContextProvider";
// import { useLocaleContext } from "@lib/context/AppContextProvider/LocaleContextProvider";
import { IoLanguageOutline } from "react-icons/io5";
import {
  StyledLangItem,
  StyledLangIcon,
  StyledLangIconWrapper,
} from "./index.styled";
import { LanguageProps } from "@lib/types/Apps";
import { StyledHeaderButton } from "@lib/components/StyledComponents/layout";
import { useTypedSelector } from "@lib/redux";

type AppLanguageSwitcherProps = {
  iconOnly?: boolean;
};

const AppLanguageSwitcher: React.FC<AppLanguageSwitcherProps> = () => {
  const { locale } = useLocaleContext();
  const { updateLocale } = useLocaleActionsContext();
  // const { updateDirection } = useLayoutActionsContext();
  const { height } = useTypedSelector((state) => state.screen.header);

  const changeLanguage = (language: LanguageProps) => {
    // if (rtlLocale.indexOf(language.locale) !== -1) {
    //   updateDirection(LayoutDirection.RTL);
    // } else {
    //   updateDirection(LayoutDirection.LTR);
    // }
    updateLocale(language);
  };

  const items = languageData.map((language) => {
    return {
      key: language.locale,
      label: (
        <StyledLangItem
          key={language.locale}
          onClick={() => changeLanguage(language)}
        >
          <h4>{language.name}</h4>
        </StyledLangItem>
      ),
    };
  });

  return (
    <StyledLangIconWrapper height={height - 5}>
      <Dropdown
        menu={{
          items,
          selectedKeys: [locale.locale],
        }}
        trigger={["click"]}
        overlayStyle={{ zIndex: 1052 }}
        placement="bottom"
      >
        <StyledHeaderButton>
          <StyledLangIcon>
            <IoLanguageOutline />
          </StyledLangIcon>
        </StyledHeaderButton>
      </Dropdown>
    </StyledLangIconWrapper>
  );
};

export default AppLanguageSwitcher;
